<template>
  <v-ons-page>
    <v-ons-toolbar class="home-toolbar">
      <div class="left">
        <v-ons-button modifier="quiet" style="margin: 6px 0" @click="goBack()">＜戻る</v-ons-button>
      </div>
      <div class="center" style="text-align: center;">{{ msg }}</div>
      <div class="right"></div>
    </v-ons-toolbar>

    <!-- 運営への連絡 -->
    <v-ons-list>
      <v-ons-list-header>運営への連絡手段</v-ons-list-header>
      <v-ons-list-item>
        <div class="left"><v-ons-icon style="color: #5D99FF;" icon="fa-envelope"></v-ons-icon></div>
        <div class="center">
          <a href="mailto:support@mileys.co.jp">メール</a>
        </div>
      </v-ons-list-item>
      <v-ons-list-header>Webサイト</v-ons-list-header>
      <v-ons-list-item>
        <div class="left"><v-ons-icon style="color: #5D99FF;" icon="fa-home"></v-ons-icon></div>
        <div class="center">
          <!-- デフォルト=標準のブラウザ（Chrome）で開く -->
          <v-ons-button modifier="quiet" @click="openExternalLink('https://lasmeru.mileys.co.jp')">公式サイトTOP</v-ons-button>
        </div>
      </v-ons-list-item>
      <v-ons-list-header>Twitterアカウント</v-ons-list-header>
      <v-ons-list-item>
        <div class="left"><v-ons-icon style="color: #5D99FF;" icon="fa-twitter"></v-ons-icon></div>
        <div class="center">
          <v-ons-button modifier="quiet" @click="openExternalLink('https://twitter.com/MileysInc')">公式Twitter</v-ons-button>
        </div>
      </v-ons-list-item>
      <v-ons-list-header>サービス利用規約</v-ons-list-header>
      <v-ons-list-item>
        <div class="left"><v-ons-icon style="color: #5D99FF;" icon="fa-grimace"></v-ons-icon></div>
        <div class="center">
          <v-ons-button modifier="quiet" @click="serviceTermsOn = true">サービス利用規約</v-ons-button>
        </div>
      </v-ons-list-item>
      <v-ons-list-header>個人情報保護方針</v-ons-list-header>
      <v-ons-list-item>
        <div class="left"><v-ons-icon style="color: #5D99FF;" icon="fa-user-shield"></v-ons-icon></div>
        <div class="center">
          <v-ons-button modifier="quiet" @click="privacyPolicyOn = true">プライバシーポリシー</v-ons-button>
        </div>
      </v-ons-list-item>
      <v-ons-list-header>アプリバージョン</v-ons-list-header>
      <v-ons-list-item>
        <div class="center">
          <span style="font-size: 0.9em; color: gray;">ver {{appVersion}}</span>
        </div>
      </v-ons-list-item>
    </v-ons-list>
  
      <v-ons-dialog cancelable :visible.sync="serviceTermsOn">
      <div class="dialogview2">
        <!-- <p style="font-size: 0.5rem" v-html="serviceTerms"></p> -->
        <service-terms></service-terms>
        <v-ons-button modifier="large" @click="serviceTermsOn = false">閉じる</v-ons-button>
      </div>
    </v-ons-dialog>

    <v-ons-dialog cancelable :visible.sync="privacyPolicyOn">
      <div class="dialogview2">
        <!-- <p style="font-size: 0.5rem" v-html="serviceTerms"></p> -->
        <privacy-policy></privacy-policy>
        <v-ons-button modifier="large" @click="privacyPolicyOn = false">閉じる</v-ons-button>
      </div>
    </v-ons-dialog>
  
  </v-ons-page>
</template>

<script>
// import firebase from 'firebase'
import common from '../util/common'
import ServiceTerms from './AccountChildren/ServiceTerms'
import PrivacyPolicy from './AccountChildren/PrivacyPolicy'

export default {
  name: 'AboutMileyRoot',
  mixins: [common],
  components: {ServiceTerms, PrivacyPolicy},
  data () {
    return {
      componentName: 'AboutMileyRoot',
      category: 'about',
      msg: 'ラスメルについて',
      path: '',
      privacyPolicyOn: false,
      serviceTermsOn: false
    }
  },

  created () {
    // console.log('Created ', this.componentName)
  },

  mounted () {
    // console.log('Mounted ', this.componentName)
  },

  filters: {
  },

  methods: {
    openExternalLink (url) {
      // if (this.$ons.isAndroid) {
      //   console.log('isAndroid!!!')
      //   navigator.app.loadUrl(url, {openExternal: true})
      // } else if (this.$ons.isIOS) {
      //   console.log('isIOS !!!')
      //   window.open(url, '_system')
      // } else {
      //   console.log('isOthers !!!')
      window.open(url, '_system')
      // }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../src/assets/css/miley.css";
</style>



// WEBPACK FOOTER //
// src/components/AboutMileyRoot.vue